import React, { lazy } from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function Hero() {
  return <section className="bg-brand-bg text-brand-text px-4 pt-8 pb-10" data-id="element-67">
      <div className="max-w-xl mx-auto flex flex-col items-center text-center" data-id="element-68">
        <h1 className="text-2xl md:text-3xl font-black mb-4 leading-tight" data-id="element-69">
          ⚡{' '}
          <span className="text-yellow" data-id="element-70">
            Convertite en Electricista Práctico
          </span>{' '}
          y Empezá a Generar Ingresos con un Oficio que Siempre Tiene Trabajo
        </h1>

        <p className="text-sm md:text-base text-brand-text mb-6 leading-relaxed" data-id="element-71">
          Con planos reales, diagramas profesionales, instalaciones paso a paso
          y sistemas utilizados todos los días por electricistas de verdad.
        </p>

        <div className="w-full mb-6 cursor-pointer" onClick={scrollToCompra} data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/fc8h4sZJtQd8JLx6F9xUmP/ChatGPT-Image-8-jun-2026_-17_19_48.webp" alt="Mega Pack Maestro Electricista" loading="lazy" className="w-full h-auto rounded-lg" data-id="element-73" />
        </div>

        <Button className="text-sm md:text-base py-3 whitespace-nowrap" data-id="element-74">
          🔴 SÍ, QUIERO EL MEGA PACK AHORA
        </Button>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 mt-4 text-xs md:text-sm font-bold text-brand-muted" data-id="element-75">
          <span className="text-yellow" data-id="element-76">✓ Garantía 7 días</span>
          <span className="text-yellow" data-id="element-77">✓ Pago seguro</span>
          <span className="text-yellow" data-id="element-78">✓ Acceso inmediato</span>
          <span className="text-yellow" data-id="element-79">✓ Pagas en tu moneda local</span>
        </div>
      </div>
    </section>;
}